<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<footer class="the-footer flex-wrap justify-between" :class="classes">
		<p>
			<span>© {{ new Date().getFullYear() }}, {{ company }}. Alle Rechte vorbehalten.</span>
		</p>
	</footer>
</template>

<script>
export default {
	name: 'the-footer',
	props: {
		classes: {
			type: String
		}
	},
	computed: {
		company() {
			const host = this.$store.state.website.currentHostname;
			const minimized = host
				.replace('plattform.', '')
				.split('.')[0];

			return minimized[0].toUpperCase() + minimized.substr(1);
		}
	}
}
</script>
